
import { Link } from 'react-router-dom'
import SearchBar from './SearchBar'
import { AppBar } from '@mui/material';
import { Toolbar } from '@mui/material';
import VideoUploadModal from './VideoUploadModal';

function Header({performSearch, setSearchText, searchText}) {

  return (
<AppBar sx={{marginBottom:'30px'}} position='static'>
<Toolbar style={{ display: 'flex', justifyContent: 'space-between' }}>
<Link to='/'>
  <img src='/xflix-logo.png' alt='Logo' style={{ height: '35px', marginRight: '10px' }}/>
  </Link>
  <SearchBar performSearch={performSearch} setSearchText={setSearchText} searchText={searchText}/>
  <VideoUploadModal />
</Toolbar>
</AppBar>
  )
}

export default Header
